const defaultState = {
  team_opts: [],
  opt_details: {},
  custom_opt_types: [],
  create_opt_phase: "one",
  event_details: {
    title: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    start_timestamp: "",
    end_timestamp: "",
    type: "",
    category: "",
    participants: []
  },
  dataViewChallenge: {},
  prefilledFormObject: {},
  prefillChallengeForm: false,
  parcipantsViewChallenge: [],
  uploadedImgUrl: "",
  uploadedImgName: "",
  barDataLeftPercentage: 0,
  barDaysLeftPercentage: 0,
  daysLeftChallenge: 0,
  editChallenge: false,
  useTemplate: false
};

const optReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_TEAM_OPTS": {
      return {
        ...state,
        team_opts: action.data
      };
    }
    case "SET_OPT_DETAILS": {
      return {
        ...state,
        opt_details: action.data
      };
    }
    case "SET_CUSTOM_OPT_TYPES": {
      return {
        ...state,
        custom_opt_types: action.data
      };
    }
    case "SET_CREATE_OPT_PHASE": {
      return {
        ...state,
        create_opt_phase: action.data
      };
    }
    case "SET_EVENT_DETAILS": {
      return {
        ...state,
        event_details: action.data
      };
    }

    case "SET_DATA_VIEW_CHALLENGE": {
      return {
        ...state,
        dataViewChallenge: action.data
      };
    }
    case "SET_UPLOAD_IMG_CHALLENGES": {
      return {
        ...state,
        uploadImgUrl: action.data
      };
    }
    case "SET_CHALLENGES_IMG_NAME": {
      return {
        ...state,
        uploadedImgName: action.data
      };
    }
    case "SET_PARTICIPANTS_VIEW_CHALLENGE": {
      return {
        ...state,
        parcipantsViewChallenge: action.data
      };
    }
    case "SET_PREFILL_FORM": {
      return {
        ...state,
        prefilledFormObject: action.data
      };
    }
    case "SET_PREFILL_FORM_STATE": {
      return {
        ...state,
        prefillChallengeForm: action.data
      };
    }
    case "SET_DAYS_LEFT": {
      return {
        ...state,
        daysLeftChallenge: action.data
      };
    }
    case "SET_BAR_DATA_LEFT_PERCENTAGE": {
      return {
        ...state,
        barDataLeftPercentage: action.data
      };
    }
    case "SET_BAR_DAYS_LEFT_PERCENTAGE": {
      return {
        ...state,
        barDaysLeftPercentage: action.data
      };
    }
    case "SET_EDIT_CHALLENGE": {
      return {
        ...state,
        editChallenge: action.data
      };
    }
    case "SET_USE_TEMPLATE": {
      return {
        ...state,
        useTemplate: action.data
      };
    }
    default:
      return state;
  }
};

export default optReducer;
